
import {
    addToEndOfChain,
} from "@insite/client-framework/HandlerCreator";
import { chain ,RemoveAttributeValueFilters} from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";

// get the type of props using this
type HandlerParameter = Parameters<typeof RemoveAttributeValueFilters>[0];

function ClearMyVehicleValueFilter(props: HandlerParameter) {
     props.dispatch?.({
        type: "MyVehicle/Filter/MyAttrubuteValue", 
        valueIds:props.parameter.attributeValueIds 
    } as any) ; 
}
addToEndOfChain(chain, ClearMyVehicleValueFilter);
